import ScrollOut from 'scroll-out';
// import Rellax from 'rellax';
import Sliders from './modules/sliders';
import * as bootstrap from 'bootstrap';
import StickyNav from './modules/sticky-nav'

// expose bs globally again
window.bootstrap = bootstrap;

/* ------------------------------------------------
* ** Clickable links with a dropdown menu
--------------------------------------------------- */

var allLinks = document.querySelectorAll('.the-dropdown-toggle');

for (var i = 0; i < allLinks.length; i++) {
  var link = allLinks[i];

  if (link.href !== '#' && link.classList.contains('dropdown-toggle')) {
    link.addEventListener('click', function (e) {
      if (e.target.classList.contains('dropdown-toggle')) {
        window.location = e.currentTarget.href;
      }
    });
  }
}

var cf7Exists = document.querySelector('.wpcf7');

if (cf7Exists) {
  document.addEventListener(
    'wpcf7mailsent',
    function (event) {
      var getUrl = window.location;
      var baseUrl = getUrl.protocol + '//' + getUrl.host + '/' + getUrl.pathname.split('/')[1];
      location = baseUrl + '/thank-you';
    },
    false
  );
}

// Scroll effects

const laptopMedia = window.matchMedia('(min-width: 1200px)');

if (laptopMedia.matches) {
  ScrollOut({
    once: true,
    threshold: 0.3,
  });

  StickyNav();

  // // // Accepts any class name
  // var rellax = new Rellax('.with-parallax', {
  //   center: true,
  // });
}

Sliders();
